// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-date-editor[data-v-5991eb3b]  .el-range-input{min-width:65px}.el-date-editor[data-v-5991eb3b]  .el-range-separator{min-width:20px;padding:0}", ""]);
// Exports
module.exports = exports;
